module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', _vm._l((_vm.associateList), function(associate) {
    return _c('div', {
      staticClass: "control-label text-label"
    }, [_c('siteEvaluation', {
      ref: "siteEval",
      refInFor: true,
      attrs: {
        "head": associate,
        "culturalResource": _vm.culturalResource,
        "onEvaluationSave": _vm.loadData,
        "isQaqc": _vm.isQaqc,
        "isConsultantSubmitted": _vm.isSubmitted,
        "isAgencySubmitted": _vm.isAgencySubmitted,
        "hasAgencyAccess": _vm.hasAgencyAccess,
        "hasShpoAccess": _vm.hasShpoAccess,
        "isConditionReport": _vm.isConditionReport,
        "isInternalReview": _vm.isInternalReview,
        "isNormalization": _vm.isNormalization
      }
    })], 1)
  })), _vm._v(" "), (_vm.isSegment) ? _c('div', [_c('segmentEvaluation', {
    ref: "segmentEval",
    attrs: {
      "segmentHead": _vm.segmentHead,
      "segHeadEval": _vm.segHeadEval,
      "culturalResource": _vm.culturalResource,
      "isQaqc": _vm.isQaqc,
      "isConsultantSubmitted": _vm.isSubmitted,
      "isAgencySubmitted": _vm.isAgencySubmitted,
      "hasAgencyAccess": _vm.hasAgencyAccess,
      "hasShpoAccess": _vm.hasShpoAccess,
      "isConditionReport": _vm.isConditionReport,
      "isInternalReview": _vm.isInternalReview,
      "onEvaluationSave": _vm.loadData,
      "isNormalization": _vm.isNormalization
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-offset"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('workflowHistory', {
    attrs: {
      "workflowInstanceStatusDtoList": _vm.workflowInstanceStatusDtoList
    }
  }), _vm._v(" "), _c('workflowSubmit', {
    ref: "workflowSubmit",
    attrs: {
      "workflowStatusDtoNextList": _vm.nextWorkflowStatusList,
      "workflowInstanceId": _vm.workflowInstance.workflowInstanceId
    },
    on: {
      "workflowSubmitOnSubmitSuccess": _vm.workflowSubmitOnSubmitSuccess
    }
  }), _vm._v(" "), _c('user-assignment', {
    ref: "userAssignment",
    attrs: {
      "parentId": _vm.crrId,
      "workflowId": _vm.crrWorkflowId
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Form Submission")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-842c0cf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/SiteFormEligibility.vue
// module id = 970
// module chunks = 1